// extracted by mini-css-extract-plugin
export default {"loadingIcon":"VT9BCBtHp7NCNIo_Otpv","wrapper":"yO2aPtVB34N0ehIYECmr","status":"bq737miT48k_qY_x8djC","description":"LuzoZZD8Hv8qOk4P1i5o"};